import uuid from 'uuid/v4';
import installDefaultHandlers from './handlers';
import overlord from '@/overlord';

const eventHandlers = [];

export function registerEventHandler(eventName, handler) {
  const eventHandler = { id: uuid(), eventName, handler };
  eventHandlers.push(eventHandler);
  return eventHandler;
}

export function removeEventHandler({ id }) {
  eventHandlers.forEach((eventHandler, index) => {
    if (eventHandler.id === id) {
      eventHandlers.splice(index, 1);
    }
  });
}

export function dispatchEvent(name, payload = {}, userId = null) {
  overlord.service('events').create({ name, payload, userId });
}

export default function install({ store }) {
  overlord.service('events').on('created', ({ name, payload, userId }) => {
    console.debug('Overlord event received', { name, payload, userId });
    eventHandlers
      .filter(({ eventName }) => eventName === name)
      .map(({ handler }) => handler({
        store, name, payload, userId,
      }));
  });
  installDefaultHandlers();
}
